import { Injectable } from "@angular/core";
import { timeout } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { SaveProductRequest } from "../../common/model/save-product-request";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ProductService {
  constructor(private http: HttpClient) {}

  findProductInfo(id: number, params: HttpParams) {
    const url = `${environment.url.api}/u/products/${id}/info`
    return this.http
      .get<any>(url, { params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  exists(id: number) {
    const url = `${environment.url.api}/u/products/${id}/exists`
    return this.http
      .get<any>(url)
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  existsByName(name: string) {
    const url = `${environment.url.api}/u/products/${name}/name-exists`
    return this.http
      .get<any>(url)
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  search(params: HttpParams) {
    const url = `${environment.url.api}/u/products/filtered/search`
    return this.http
      .get<any>(url, { params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  searchByCodes(params: HttpParams) {
    const url = `${environment.url.api}/u/products/filtered/codes`
    return this.http
      .get<any>(url, { params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  edit(id:number, body: SaveProductRequest) {
    const url = `${environment.url.api}/a/products/${id}`
    return this.http
      .put<any>(url, body)
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  create(body): Observable<any> {
    const url = `${environment.url.api}/a/products`;
    return this.http
      .post(url, body)
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  changeUseFlag(body): Observable<any> {
    const url = `${environment.url.api}/a/products/change-use`;
    return this.http
      .post(url, body)
      .pipe(timeout(environment.config.apiWaitingTime));
  }
}